import { ProjectLockParams } from '@/backend/access/projectLock/types';
import { I18n } from '@/i18n/I18n';

export class ProjectLock {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  projectId: string;
  lockDate: string;

  constructor(params: ProjectLockParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.projectId = params.projectId;
    this.lockDate = params.lockDate;
  }

  millisecondsUntilLockDate(): number {
    return new Date(this.lockDate).getTime() - new Date().getTime();
  }

  isLocked(): boolean {
    return this.millisecondsUntilLockDate() <= 0;
  }

  daysUntilLockDate(): number {
    return Math.ceil(this.millisecondsUntilLockDate() / (1000 * 60 * 60 * 24));
  }

  daysUntilLockDateString(): string {
    const days = this.daysUntilLockDate();
    return days === 1 ? I18n.get('oneDay') : I18n.get('countDays', { days: days.toString() });
  }
}
